import { useEffect, useContext } from "react";
//import EventSource from "eventsource";
import { useKeycloak } from "@react-keycloak/web";
import { emitter } from "./Util";
import { createUpdateNotification } from "../services/apis";
import ValueContext from "../ContextAPi/appContext";
import config from "../config";

const MlrStatusEventListener = () => {
  const appData = useContext(ValueContext);
  const { setModuleExpired } = appData;
  const { keycloak } = useKeycloak();
  const saveNotification = (payload) => {
    createUpdateNotification(payload, (err, data) => {
      if (err) {
        console.log(err.message || "Error in create or updating notification");
      } else {
        console.log("sucessfully created or updated notification");
      }
    });
  };

  useEffect(() => {
    if (!keycloak.token) {
      return;
    }
    const mlrStatusEventListenerBaseUrl =
    config.globalEventListener;
  if (!mlrStatusEventListenerBaseUrl) {
    console.error("MLR status event listener URL is not configured.");
    return;
  }
    const resourceUrl = `${mlrStatusEventListenerBaseUrl}${encodeURIComponent(
      keycloak.token,
    )}`;
    const source = new window.EventSource(resourceUrl);

    source.onopen = () => {
      console.log("Module MLR SSE connected");
    };

    source.onmessage = (e) => {
      if (
        e.data &&
        e.data !== "Subscription confirmed" &&
        !e.data.includes("heartbeat")
      ) {
        try {
          const parsedData = JSON.parse(e.data);
          if (
            parsedData.mlrStatus === "Expired" ||
            parsedData.mlrStatus === "Available for Use"
          ) {
            setModuleExpired(true);
            let notificationObj = {
              documentNumber: parsedData.elementName,
              documentId:
                parsedData.type === "Module"
                  ? parsedData.cmsdDocId
                  : parsedData.id,
              expiredAt: parsedData.timeStamp.replace(" ", "T") + ":00.000Z",
              status: parsedData.mlrStatus,
              title: parsedData.type + " Expired",
              type: parsedData.type + "s",
              updateType: "createNewNotification",
            };
            saveNotification(notificationObj);
          }
          emitter.emit("autoSync", parsedData);
        } catch (error) {
          console.error("Failed to parse MLR event data:", error);
        }
      }
    };

    source.onerror = function (err) {
      if (source.readyState === window.EventSource.CLOSED) {
        console.log("Module MLR SSE connection closed");
      }
      console.log("Module MLR SSE error", err);
    };

    return () => {
      source.close();
    };
  }, [keycloak.token, setModuleExpired]);
  return null;
};
export default MlrStatusEventListener;
